export type FieldHistoryShortcutAction = 'redo' | 'undo';

export function isEditableKeyboardTarget(target: EventTarget | null) {
  let editable = false;

  if (target instanceof HTMLElement) {
    editable = Boolean(
      target.closest('input, textarea, select, [contenteditable], [role="textbox"]'),
    );
  }

  return editable;
}

export function getFieldHistoryShortcutAction(
  event: Pick<KeyboardEvent, 'ctrlKey' | 'key' | 'metaKey' | 'shiftKey' | 'target'>,
): FieldHistoryShortcutAction | null {
  const hasModifier = event.metaKey || event.ctrlKey;
  const key = event.key.toLowerCase();

  if (hasModifier && !event.shiftKey && key === 'z') {
    return 'undo';
  }

  if (
    hasModifier
    && (
      (event.shiftKey && key === 'z')
      || (!event.shiftKey && key === 'y')
    )
  ) {
    return 'redo';
  }

  return null;
}
